import React, { useEffect, useState } from 'react';
import { Area, CartesianGrid, ComposedChart, Legend, Line, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import styles from './TemperatureCharts.module.css';
import { Alert, Table } from 'react-bootstrap';
import { getChartOnRange, getChartOnArbitrary, getChartOnAverage } from '../../../apiMethod/Administrator/lasers.js';

function TemperatureCharts({ jwt }) {
    const [sensorData, setSensorData] = useState(null);
    const [currentDate, setCurrentDate] = useState(new Date().toISOString().split('T')[0]);
    const [rangeType, setRangeType] = useState(0); // 0 - week, 1 - month, 2 - year
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 640);
    // const [showAverage, setShowAverage] = useState(false);
    // const [averageData, setAverageData] = useState(null);

    useEffect(() => {
        fetchWeatherData();
    }, [currentDate, rangeType]);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 640);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const fetchWeatherData = async () => {
        try {
            const data = await getChartOnRange(currentDate, rangeType, jwt);
            setSensorData(data);
            
            // if (showAverage) {
            //     const avg = await getChartOnAverage(data.start, data.end, jwt);
            //     setAverageData(avg);
            // }
        } catch (error) {
            console.error('Error fetching weather data:', error);
        }
    };

    const handleDateRangeChange = async (start, end) => {
        try {
            const data = await getChartOnArbitrary(start, end, jwt);
            setSensorData(data);
            
            // if (showAverage) {
            //     const avg = await getChartOnAverage(start, end, jwt);
            //     setAverageData(avg);
            // }
        } catch (error) {
            console.error('Error fetching arbitrary range data:', error);
        }
    };

    const WeatherChart = () => (
        <div className={styles.contentChart}>
            <ResponsiveContainer width="100%" height={isMobile ? 250 : 350}>
                <ComposedChart data={sensorData.items}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis 
                        dataKey="title" 
                        tick={{ fontSize: isMobile ? 10 : 12 }}
                    />
                    <YAxis 
                        yAxisId="temp" 
                        orientation="left" 
                        label={{ value: '°C', angle: -90, position: 'insideLeft' }}
                        tick={{ fontSize: 10 }}
                    />
                    <YAxis 
                        yAxisId="humidity" 
                        orientation="right" 
                        domain={[0, 100]}
                        label={{ value: '%', angle: 90, position: 'insideRight' }}
                        tick={{ fontSize: 10 }}
                    />
                    <Tooltip 
                        formatter={(value, name) => [
                            `${value} ${name === 'Температура' ? '°C' : '%'}`,
                            name === 'Температура' ?  'Температура' : 'Влажность'
                        ]}
                        // labelFormatter={(label) => `День: ${label}`}
                    />
                    <Legend />
                    <Line
                        yAxisId="temp"
                        type="monotone"
                        dataKey="temperature"
                        name="Температура"
                        stroke="#ff7300"
                        activeDot={{ r: 6 }}
                        strokeWidth={2}
                    />
                    <Area
                        yAxisId="humidity"
                        type="monotone"
                        dataKey="humidity"
                        name="Влажность"
                        stroke="#387908"
                        fill="#82ca9d"
                        fillOpacity={0.3}
                    />
                </ComposedChart>
            </ResponsiveContainer>
        </div>
    );

 if (!sensorData)
        return <Alert variant="danger" dismissible>
            <Alert.Heading>Ох, щелк! У вас ошибка!</Alert.Heading>
            <p>
                Что-то пошло не по плану, попробуйте перезагрузить страницу! Если не помогло тогда сообщите разработчику и дождитесь обновления.
            </p>
        </Alert>;

    return (
        <div className={styles.psevdoBody}>
            <div className={styles.content}>
                <div className={styles.headContent}>
                    <label className={styles.titleChart}>
                        Анализ температуры и влажности
                    </label>
                    <div className={styles.dateBox}>
                        <select 
                            className={styles.selectDate}
                            value={rangeType}
                            onChange={(e) => setRangeType(Number(e.target.value))}
                        >
                            <option value={0}>Неделя</option>
                            <option value={1}>Месяц</option>
                            <option value={2}>Год</option>
                        </select>
                        <input 
                            className={styles.selectDate} 
                            type="date" 
                            value={currentDate} 
                            onChange={(e) => setCurrentDate(e.target.value)} 
                        />
                        {/* <button 
                            className="btn btn-sm btn-outline-secondary"
                            onClick={() => setShowAverage(!showAverage)}
                        >
                            {showAverage ? 'Скрыть средние' : 'Показать средние'}
                        </button> */}
                    </div>
                </div>

                <div className={styles.infoBox}>
                    <p>Период: {sensorData.start} — {sensorData.end}</p>
                    {/* {showAverage && averageData && (
                        <p>
                            Средние значения: Температура {averageData.info.temperature.toFixed(1)}°C, 
                            Влажность {averageData.info.humidity.toFixed(1)}%
                        </p>
                    )} */}
                </div>

                <WeatherChart />

                <div className={styles.tableContainer}>
                    <Table striped bordered hover size={isMobile ? "sm" : "md"}>
                        <thead>
                            <tr>
                                <th>{rangeType == 2 ? 'Месяц' : 'День'}</th>
                                <th>Температура (°C)</th>
                                <th>Влажность (%)</th>
                            </tr>
                        </thead>
                        <tbody>
                            {sensorData.items.map((day, index) => (
                                <tr key={index}>
                                    <td>{day.title}</td>
                                    <td>{day.temperature.toFixed(1)}</td>
                                    <td>{day.humidity.toFixed(1)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>
            </div>
        </div>
    );
}

export default TemperatureCharts;